var map = {
	"./AE.svg": 654,
	"./AR.svg": 655,
	"./AT.svg": 656,
	"./AU.svg": 657,
	"./BE.svg": 658,
	"./BO.svg": 659,
	"./CA.svg": 660,
	"./CO.svg": 661,
	"./CY.svg": 662,
	"./DE.svg": 663,
	"./EE.svg": 664,
	"./ES.svg": 665,
	"./FI.svg": 666,
	"./FR.svg": 667,
	"./GB.svg": 668,
	"./GR.svg": 669,
	"./GY.svg": 670,
	"./HK.svg": 671,
	"./IE.svg": 672,
	"./IN.svg": 673,
	"./IT.svg": 674,
	"./LT.svg": 675,
	"./LU.svg": 676,
	"./LV.svg": 677,
	"./MT.svg": 678,
	"./MY.svg": 679,
	"./NL.svg": 680,
	"./NZ.svg": 681,
	"./PE.svg": 682,
	"./PH.svg": 683,
	"./PT.svg": 684,
	"./RU.svg": 685,
	"./SA.svg": 686,
	"./SG.svg": 687,
	"./SI.svg": 688,
	"./SK.svg": 689,
	"./US.svg": 690,
	"./UY.svg": 691,
	"./ZA.svg": 692,
	"./null.svg": 693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;